<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName"
      ><i class="lt"></i><i class="rt"></i>
      <el-tab-pane name="config">
        <span slot="label"
          ><i class="iconfont iconcheck"></i
          ><i class="border"></i> 巡检点配置</span
        >
        <normalNav :parent="self">
          <button class="GreenSmBtn" @click="add">新增</button>
        </normalNav>
        <div class="searchForm1">
          <searchForm
            :items="items"
            :formPlus="form_config"
            ref="searchForm_config"
          >
            <template slot="last">
              <el-form-item label="选择区域" prop="area_id">
                <el-input
                  v-model="form_config.regionName"
                  placeholder="请选择区域"
                  @focus="areaTreeVisible = true"
                ></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <easyTable
            apiUrl="operation/checkPoint/findAll"
            :parent="self"
            :config="config"
            :other="other"
            ref="table_config"
          >
            <template slot="last">
              <el-table-column label="操作" width="300" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="edit(scope.row)"
                    >编辑</el-link
                  >
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteMsg(scope.$index, scope.row)"
                    >删除</el-link
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <el-dialog
          class="editDialog"
          :title="title"
          :visible.sync="editDialogVisible"
        >
          <el-form :model="addForm" :rules="addRule" ref="addForm">
            <el-form-item label="巡检点:" prop="name">
              <el-input v-model.trim="addForm.name"></el-input>
            </el-form-item>
            <el-form-item label="选择区域" prop="regionName">
              <el-input
                v-model="addForm.regionName"
                placeholder="请选择区域"
                @focus="addAreaTreeVisible = true"
              ></el-input>
            </el-form-item>
            <el-form-item label="nfc:" prop="nfc">
              <el-input v-model.trim="addForm.nfc"></el-input>
            </el-form-item>
            <el-form-item label="巡检确认项:" prop="list">
              <el-button type="success" @click="addList">添加</el-button>
              <div v-for="(i, index) in list" :key="index">
                <el-input v-model.trim="i.patrolConfirmation">
                  <el-button slot="append" @click="deleteList(index)">删除</el-button>
                </el-input>
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="editDialogVisible = false"
              >取消</el-button
            >
            <el-button class="confirmButton" type="primary" @click="sureAdd"
              >确定</el-button
            >
          </div>
        </el-dialog>
        <!-- 区域树 -->
        <mountPoint
          :hasChildNodes="true"
          :dialogVisible="areaTreeVisible"
          @regionTreeClose="areaTreeVisible = false"
          @regionTreeData="selRegionData"
        ></mountPoint>
        <mountPoint
          :hasChildNodes="true"
          :dialogVisible="addAreaTreeVisible"
          @regionTreeClose="addAreaTreeVisible = false"
          @regionTreeData="addSelRegionData"
        ></mountPoint>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { obj2urlsp, descriptor } from "utils";

export default {
  data() {
    return {
      tabName: "config",
      form_config: {},
      title: "新增巡检点",
      addForm: {},
      list: [],
      editDialogVisible: false,
      data: {},
      other: {},
      config: [
        {
          label: "序号",
          prop: "id",
        },
        {
          label: "巡检点",
          prop: "name",
        },
        {
          label: "区域",
          prop: "areaName",
        },
        {
          label: "NFC编码",
          prop: "nfc",
        },
      ],
      items: [
        {
          type: "input",
          prop: "name",
          label: "巡检点",
          placeholder: "",
        },
      ],
      areaTreeVisible: false,
      addAreaTreeVisible: false,
    };
  },
  computed: {
    self() {
      return this;
    },
    addRule() {
      let that = this;
      return {
        name: descriptor(new Map([[true, "请输入巡检点名称"]]), "blur"),
        regionName: descriptor(new Map([[true, "请选择巡检点区域"]]), "blur"),
        nfc: descriptor(new Map([[true, "请输入nfc"]]), "blur"),
      };
    },
  },
  methods: {
    addList() {
      this.list.push({
        patrolConfirmation: "",
      });
    },
    deleteList(i) {
      this.list.splice(i, i + 1);
    },
    reset_config(fn) {
      fn();
      this.form_config = {};
    },
    search_config(fn) {
      fn();
    },
    add() {
      this.title = "新增巡检点";
      this.addForm = {};
      this.list = [];
      this.editDialogVisible = true;
      this.$refs.addForm.resetFields();
    },
    edit(data) {
      this.title = "编辑巡检点";
      this.$set(this.addForm, "id", data.id);
      this.$set(this.addForm, "area_id", data.area_id);
      this.$set(this.addForm, "regionName", data.areaName);
      this.$set(this.addForm, "name", data.name);
      this.$set(this.addForm, "nfc", data.nfc);
      this.list = data.list;
      this.editDialogVisible = true;
    },
    deleteMsg(index, row) {
      this.$confirm("确定删除巡检点?", "", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButton",
        cancelButtonClass: "cancelButton",
        type: "warning",
      }).then(() => {
        this.$axiosdelete("operation/checkPoint/delete", {
          params: {
            id: row.id,
          },
        }).then((res) => {
          this.$refs.table_config.getData();
        });
      }).catch(()=>{

      })
    },
    selRegionData(data) {
      this.$set(this.form_config, "regionName", data.name);
      this.$set(this.form_config, "area_id", data.id);
    },
    addSelRegionData(data) {
      this.$set(this.addForm, "regionName", data.name);
      this.$set(this.addForm, "area_id", data.id);
    },
    sureAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$axiospost("operation/checkPoint/save", {
            ...this.addForm,
            list: this.list,
          }).then((res) => {
            this.editDialogVisible = false;
            this.$refs.table_config.getData();
          });
        }
      });
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    mountPoint: () => import("./mountPoint/"),
  },
  mounted() {
    // this.$message({
    //   duration: 6000,
    //   message: '这是一条消息提示'
    // });
    // this.$notify.info({
    //   title: '消息',
    //   message: '这是一条消息的提示消息',
    //   duration: 6000,
    // });
    // this.$message({
    //   duration: 5000,
    //   message: '恭喜你，这是一条成功消息',
    //   type: 'success'
    // });
    // this.$notify({
    //   title: '成功',
    //   message: '这是一条成功的提示消息',
    //   type: 'success',
    //   duration: 5000,
    // });
    // this.$message({
    //   duration: 4000,
    //   message: '警告哦，这是一条警告消息',
    //   type: 'warning'
    // });
    // this.$notify({
    //   title: '警告',
    //   message: '这是一条警告的提示消息',
    //   type: 'warning',
    //   duration: 4000,
    // });
    // this.$message({
    //   duration: 3000,
    //   message: '错了哦，这是一条错误消息',
    //   type: 'error'
    // });
    // this.$notify.error({
    //   title: '错误',
    //   message: '这是一条错误的提示消息',
    //   type: 'error',
    //   duration: 3000,
    // });
  },
};
</script>

<style lang="less" scoped>
.el-input-group__append {
  border: 0;
  background-color: #F56C6C;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/xunjian/xunjianConfig/index.vue